// WP-07 — AppShell (LLD-05 §4; UX v1.4 §3): tenant-branded header — LIVE since
// WP-22 (D-F5 RESOLVED): brandLabel() resolves the org's branding over the
// Steier defaults. Role-filtered sidebar via navFor(role), content outlet.
// WP-26 (CR-004): the notification bell is a live global shell element
// (foreman delay reports). Global search still arrives with its vertical.
// WP-T-2 (UX v1.6 §3, Theme B shell): "+ New job" is the persistent primary
// action in the sidebar — a link to the EXISTING O-04 route, shown to exactly
// the roles O-03 already shows it to (canCaptureJobs; D-WPT-2-3). The header
// is colour.identity with on.identity text and focus ring; the active nav
// item is brand.surface + brand.accessible text + a 4 px edge (tokens.css).
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { apiClient } from "../api/api-client";
import { AuthService } from "../auth/auth-service";
import { canCaptureJobs } from "../auth/roles";
import { useSession } from "../auth/session-store";
import { t } from "../i18n/i18n";
import { navFor } from "../screens/registry";
import { useShellBrand } from "./document-title";
import { NotificationBell } from "./notification-bell";

const authService = new AuthService(apiClient);

export function AppShell() {
  const navigate = useNavigate();
  const role = useSession((s) => s.role);
  const user = useSession((s) => s.user);
  // WP-22 (D-F5): tenant emailDisplay > org name > subdomain slug > platform.
  // UX-4a: the same label titles the document (document-title.tsx).
  const brand = useShellBrand();

  const onSignOut = async () => {
    await authService.logout();
    navigate("/sign-in", { replace: true });
  };

  return (
    <div className="shell">
      <a className="skip-link" href="#main">
        {t("shell.skipToContent")}
      </a>
      <header className="shell__header">
        <span className="shell__brand">{brand}</span>
        <span className="shell__user">
          <NotificationBell />
          {user ? <span>{user.email}</span> : null}
          <button
            type="button"
            className="button button--ghost"
            onClick={() => void onSignOut()}
          >
            {t("shell.signOut")}
          </button>
        </span>
      </header>
      <nav className="shell__nav" aria-label={t("shell.navLabel")}>
        <ul>
          {(role ? navFor(role) : []).map((item) => (
            <li key={item.id}>
              <NavLink to={item.path} end={item.path === "/jobs"}>
                {t(item.labelKey)}
              </NavLink>
            </li>
          ))}
        </ul>
        {canCaptureJobs(role) ? (
          <Link
            className="button button--primary shell__new-job"
            to="/jobs/new"
            data-testid="shell-new-job"
          >
            {t("shell.newJob")}
          </Link>
        ) : null}
      </nav>
      {/* UX-4a (UX2-SHELL-8): tabIndex -1 makes the skip link's target take
          focus, so the next Tab continues from the content, not the header. */}
      <main id="main" className="shell__main" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
}
